const formSteps = [
  '/',
  '/details',
  '/access',
  '/assignment',
  '/attachments',
];

export default formSteps;
